import { useTranslation } from "react-i18next"

export function ConfirmationModal(
  {
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
  }: {
    isOpen: boolean,
    onClose: () => void,
    onConfirm: () => void,
    title?: string,
    message?: string,
  }) {
  const { t } = useTranslation(['booking', 'common'])
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl"
      >
        <h2 className="text-2xl font-bold mb-4">{title ?? t('booking:confirmationTitle')}</h2>
        <p className="mb-6 text-sm text-gray-600">{message ?? t('booking:confirmBookService')}</p>
        <div className="flex justify-end gap-2">
          <button
            className="rounded-md bg-red-500 px-4 py-2 text-white shadow-sm transition hover:brightness-110"
            onClick={onClose}
          >
            {t('common:cancel')}
          </button>
          <button
            className="rounded-md bg-blue-500 px-4 py-2 text-white shadow-sm transition hover:brightness-110"
            onClick={onConfirm}
          >
            {t('common:confirm')}
          </button>
        </div>
      </div>
    </div>
  )
}
